import React from 'react';
import Contact from '../Contact/Contact';
import './ContactMe.css'

const ContactMe = () => {
    return (
        <div className="contact-section-padding">
            <Contact></Contact>
        </div>
    );
};

export default ContactMe;